import StripeRedirect from "./stripe";
export default function useRoutes() {
  return [
    {
      id: "stripe",
      path: "/stripe",
      component: <StripeRedirect />,
    },
  ];
}